import {
    FETCH_INVOICE,
    FETCH_INVOICES,
    FETCH_INVOICE_STATS,
    FETCH_ATTENDEE_INVOICES
} from '../actions/invoice';


export const initialState = {
    isFetching: true,
    data: null
};

export const invoices = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVOICES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVOICES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const attendeeInvoices = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ATTENDEE_INVOICES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ATTENDEE_INVOICES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const invoice = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVOICE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVOICE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const invoiceStats = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_INVOICE_STATS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_INVOICE_STATS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/invoice.js